var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrediticia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.996094 5.5C0.996094 4.39543 1.89152 3.5 2.99609 3.5H15.6541C16.7586 3.5 17.6541 4.39543 17.6541 5.5V13.0787C17.6541 14.1833 16.7586 15.0787 15.6541 15.0787H2.99609C1.89153 15.0787 0.996094 14.1833 0.996094 13.0787V5.5ZM15.6541 5.5L2.99609 5.5V7H15.5C15.5538 7 15.6055 7.00848 15.6541 7.02418V5.5ZM15.6541 8.97582C15.6055 8.99152 15.5538 9 15.5 9H2.99609V13.0787H15.6541V8.97582ZM21.004 10.9219H19.0724V8.92188H21.004C22.1086 8.92188 23.004 9.81731 23.004 10.9219V18.5006C23.004 19.6052 22.1086 20.5006 21.004 20.5006H8.34604C7.24147 20.5006 6.34604 19.6052 6.34604 18.5006V16.5533H8.34604V18.5006L21.004 18.5006V10.9219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrediticia);
export default __webpack_public_path__ + "static/media/Crediticia.5e00ea54b65b8f68597713147e542b77.svg";
export { ForwardRef as ReactComponent };